module.exports = __webpack_public_path__ + "static/media/icon-suitcase.fe6f1ed7.svg";